
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HANDBOOK_TEMPLATE_LVL } from "../model/slice";
/** Возвращает утровень вложенности в структуру шаблона.
Должен вызываться внутри Route с параметрами шаблонов */
const useHandbookLvl = () => {
  const { templateId, sectionId, subSectionId } = useParams<{
    templateId: string;
    sectionId?: string;
    subSectionId?: string;
  }>();
  const [lvl, setLvl] = useState(HANDBOOK_TEMPLATE_LVL.TEMPLATES);
  useEffect(() => {
    const nextLvl = !!subSectionId // Просматриваем структуру подсекции
      ? HANDBOOK_TEMPLATE_LVL.EXPENDITURES
      : // Просматриваем структуру раздела (список подсекций) или структуру шаблона (список разделов)
      !!sectionId || !!templateId
      ? HANDBOOK_TEMPLATE_LVL.SECTIONS
      : // Просматриваем список шаблонов
        HANDBOOK_TEMPLATE_LVL.TEMPLATES;
    if (nextLvl === lvl) return;
    setLvl(nextLvl);
  }, [templateId, sectionId, subSectionId]);
  return { handbookLvl: lvl, templateId, sectionId, subSectionId };
};
export default useHandbookLvl;